<div class="px-3 px-md-4" aria-busy="true" aria-label="Loading dashboard">

  <!-- Header -->
  <div class="dashboard-header mb-3 text-center">
    <app-skeleton width="320px" height="18px" borderRadius="6px" class="d-inline-block"></app-skeleton>
  </div>

  <!-- Strategy Distribution -->
  <section class="charts-section mb-3">
    <div class="row g-3">
      <div class="col-12 col-lg-12">
        <div class="card shadow-sm h-100 rounded-3">
          <!-- card-header mirrors bg-white header with title + KPI box, min-height: 78px -->
          <div class="card-header bg-white border-bottom py-2 px-3 skl-strategy-header">
            <div class="d-flex justify-content-between align-items-start gap-3">
              <div>
                <app-skeleton width="180px" height="16px" borderRadius="4px" marginBottom="6px"></app-skeleton>
                <app-skeleton width="240px" height="22px" borderRadius="4px" marginBottom="0"></app-skeleton>
              </div>
              <!-- KPI box placeholder: mirrors row-layout strategy-box -->
              <div class="skl-kpi-box">
                <app-skeleton width="90px" height="14px" borderRadius="3px" marginBottom="0"></app-skeleton>
                <app-skeleton width="40px" height="18px" borderRadius="3px" marginBottom="0"></app-skeleton>
              </div>
            </div>
          </div>
          <div class="card-body p-3">
            <!-- 3-column KPI grid -->
            <div class="strategy-boxes-grid mt-3">
              @for (item of tableRows.slice(0, 3); track item) {
                <div class="skl-strategy-card">
                  <div>
                    <app-skeleton width="70%" height="12px" borderRadius="3px" marginBottom="10px"></app-skeleton>
                    <app-skeleton width="50%" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
                  </div>
                  <app-skeleton width="24px" height="24px" borderRadius="50%"></app-skeleton>
                </div>
              }
            </div>
            <!-- Progress bar -->
            <app-skeleton width="100%" height="40px" borderRadius="6px" marginBottom="0" class="d-block mt-4"></app-skeleton>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Candidates Section — 2 cards -->
  <section class="candidates-section mb-3">
    <div class="row" style="margin-bottom: 20px;">
      @for (col of tableRows.slice(0, 2); track col) {
        <div class="col-12 col-xl-6">
          <div class="card shadow-sm h-100 rounded-3">
            <!-- Blue card header -->
            <div class="card-header skl-blue-header py-2 px-3">
              <app-skeleton width="60%" height="15px" borderRadius="4px" marginBottom="0" class="skl-header-bar"></app-skeleton>
            </div>
            <!-- Table body -->
            <div class="card-body p-0">
              <div class="skl-table-wrap">
                <!-- Table head row -->
                <div class="skl-table-head-row">
                  <app-skeleton width="30%" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  <app-skeleton width="30%" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  <app-skeleton width="25%" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                </div>
                <!-- 5 data rows -->
                @for (row of tableRows; track row) {
                  <div class="skl-table-row">
                    <app-skeleton width="80%" height="12px" borderRadius="3px" marginBottom="4px"></app-skeleton>
                    <app-skeleton width="50%" height="11px" borderRadius="3px" marginBottom="0"></app-skeleton>
                    <app-skeleton width="80%" height="12px" borderRadius="3px" marginBottom="4px"></app-skeleton>
                    <app-skeleton width="50%" height="11px" borderRadius="3px" marginBottom="0"></app-skeleton>
                    <app-skeleton width="65%" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  </div>
                }
              </div>
            </div>
            <!-- Donut footer -->
            <div class="card-footer bg-light">
              <app-skeleton width="140px" height="13px" borderRadius="3px" marginBottom="12px"></app-skeleton>
              <div class="skl-donut-row">
                <!-- Stats column -->
                <div class="skl-donut-stats">
                  @for (s of tableRows.slice(0, 3); track s) {
                    <div class="skl-stat-row">
                      <app-skeleton width="28px" height="16px" borderRadius="3px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="44px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                    </div>
                  }
                </div>
                <!-- Donut placeholder -->
                <div class="skl-donut-circle-wrap">
                  <div class="skl-donut-circle"></div>
                </div>
                <!-- Legend column -->
                <div class="skl-donut-legend">
                  @for (l of tableRows.slice(0, 3); track l) {
                    <div class="skl-legend-row">
                      <div class="skl-legend-dot"></div>
                      <app-skeleton width="40px" height="11px" borderRadius="3px" marginBottom="0"></app-skeleton>
                      <app-skeleton width="28px" height="11px" borderRadius="3px" marginBottom="0"></app-skeleton>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </section>

</div>
